import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHexagonLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	id: "svg1",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { id: "defs1" }), /* @__PURE__ */ _jsx("path", {
		id: "path2",
		d: "m 12,2.25 c -0.549874,0 -1.099247,0.1413615 -1.591797,0.4257813 L 4.7226562,5.9589844 C 3.7373172,6.5280338 3.1308594,7.579288 3.1308594,8.7167969 v 6.5664061 c 0,1.137899 0.6067578,2.188913 1.5917968,2.757813 l 5.6855468,3.28125 c 0.985199,0.568899 2.200348,0.568899 3.185547,0 l 5.685547,-3.28125 c 0.984999,-0.5689 1.591797,-1.619914 1.591797,-2.757813 V 8.7167969 c 0,-1.1375089 -0.606498,-2.1887631 -1.591797,-2.7578125 L 13.59375,2.6757813 C 13.1012,2.3913615 12.549874,2.25 12,2.25 Z m 0,1.5 c 0.290825,0 0.58325,0.074165 0.84375,0.2246094 l 5.685547,3.2832031 c 0.520899,0.3008097 0.841797,0.856775 0.841797,1.4589844 v 6.5664061 c 0,0.6019 -0.320698,1.157985 -0.841797,1.458984 l -5.685547,3.28125 c -0.520999,0.3009 -1.164547,0.3009 -1.685547,0 L 5.4726562,16.742187 C 4.9515468,16.441188 4.6308594,15.885103 4.6308594,15.283203 V 8.7167969 c 0,-0.6021394 0.3210274,-1.1581547 0.8417968,-1.4589844 L 11.158203,3.9746094 C 11.418703,3.8241645 11.709175,3.75 12,3.75 Z"
	})]
});
export default SvgHexagonLine;
